import { ref } from 'vue'

export function useTextOverflow() {
  const overflowMap = ref<Record<string, boolean>>({})

  const checkOverflow = (e: MouseEvent, key: string) => {
    const el = e.target as HTMLElement
    if (el) {
      // 检查 scrollWidth 或 scrollHeight 是否超出可见区域，若是则说明溢出显示了省略号
      overflowMap.value[key] = el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
    }
  }

  return {
    overflowMap,
    checkOverflow,
  }
}
